<template>
    <div class="">
        <div class="" v-if="!finished">
            <div class="center container login-box" style="width:500px;">
                <div class="row " v-if="login_legal_name_first || login_legal_name_last">
                        <label>Legal Name:</label> 
                        <br/>
                        <div class="input-group mb-2 mr-sm-2">
                            <input placeholder="Given Name" v-if="login_legal_name_first" class="form-control" type="text" v-model="registration.legal_name_first" required/>
                            <input placeholder="Family Name" v-if="login_legal_name_last" class="form-control" type="text" v-model="registration.legal_name_last" required/>
                        </div>
                </div>
                <div class="row " v-if="login_student_number">
                            <label class="d-block w-100">Student Number:</label> 
                        <br/>
                        <!-- <span class="help-text">&nbsp;If you know your student number, please enter it here</span> -->
                        
                        <br/>
                        <input  class="form-control" type="text" v-model="registration.student_number"/>
                        <div class="">
                            <button type="button" style="margin-top:.5rem;" class="btn btn-light btn-sm" data-toggle="modal" data-target="#huskyCardModal" data-backdrop="false">
                                How do I find my Student Number?
                            </button>
                        </div>
                </div>
                <div class="row " v-if="login_netid">
                        <label>NetID:</label> 
                        <!-- <span class="help-text">&nbsp;If you know your student number, please enter it here</span> -->
                        <br/>
                        <input  class="form-control" type="text" v-model="registration.netid"/>
                </div>
                <div class="row" v-if="login_call_name">
                        <label>Name to Call: </label>
                        <input class="form-control" type="text" v-model="registration.name" required/>
                </div>
                <div class="row" v-if="login_other">
                        <label>{{login_other_text}}</label>
                        <input class="form-control" type="text" maxlength="48" v-model="registration.other" required/>
                </div>
                <div class="row" style="margin-top:2rem;">
                    <button class="offset-3 col-6 btn btn-lg btn-primary" v-on:click="addRegistration">Submit</button>
                </div>
            </div>
        </div>
        <div v-else>
            <span v-html="success_text"></span>
        </div>

        <!-- Button trigger modal -->
        <HuskyCardModal>
        </HuskyCardModal>
        
    </div>
</template>

<script>
import { EventBus } from '../event-bus.js';
import HuskyCardModal from '../templates/HuskyCardModal';

export default {
    name: 'Login',
    components: {
        HuskyCardModal
    },
    props: [
        'socket',
        'success_text',
        'option_id',
        'login_call_name',
        'login_legal_name_first',
        'login_legal_name_last',
        'login_student_number',
        'login_netid',
        'login_other',
        'login_other_text',
        'queue_id',
        'api_root'
    ],
    data () {
        return {
            finished: false,
            registration: {
                id: null,
                name: "",
                student_number: "",
                netid: "",
                legal_name: "",
                queue_id: null,
                option_id: null
            }
        }
    },
    mounted : function () {
        var self = this;
        self.registration.queue_id = self.queue_id;
        self.registration.option_id = self.option_id;

        EventBus.$emit('resetTimer');
    },
    methods: {
        addRegistration: function () {
            let self= this;
            let url = self.api_root + 'registrationss/';
            let method = 'POST';
            let sql_data = {
                "Id": null,
                "Name" : self.registration.name,
                "LegalNameFirst" : self.registration.legal_name_first,
                "LegalNameLast" : self.registration.legal_name_last,
                'StudentNum': self.registration.student_number,
                'Other': self.registration.other,
                'NetId': self.registration.netid,
                'QueueId' : self.registration.queue_id,
                'OptionId' : self.registration.option_id
            };
            console.log(sql_data);
            fetch(url, {
                method: method,
                headers: {
                    'Accept': ' application/json, text/javascript, */*; q=0.01',
                    'Content-Type': 'application/json; charset=UTF-8',
                    'Cache': 'no-cache'
                },
                body: JSON.stringify(sql_data),
                credentials: "omit"
            }).then(function (response) {
                return response.json();
            }).then(function (response) {
                self.registration.id = response.Id;
                let message_data = {
                    "id": self.registration.id,
                    "name" :"",
                    "legal_name" : "",
                    'student_number': "",
                    'netid': "",
                    'queue_id' : self.registration.queue_id,
                    'option_id' : self.registration.option_id
                };
                let data = {name:'register', payload: message_data};
                console.log('addRegistration', data);
                EventBus.$emit('publish', data);
                
                // console.log('response',  response);
                // self.registration.Id = response.Id;
                // scServer.exchange.publish('register', self.registration);
                // console.log('post publish');
            })
            .finally(function () {
                self.finished = true;
                setTimeout(function () {
                    self.$router.push('/')
                }, 8000);
            })
            .catch(function (error) {
                console.log('fetch error', error);
            });

            
        },
       
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

label {
    text-align:left;
}


.login-box .row {
    margin-bottom:1rem;
}

</style>
